import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './conspiracy.json'; 

const Conspiracy = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Conspiracy theories, critical thinking, and media literacy. B2/C1 level reading, grammar, and discussion exercises."
            level="B2"
            title="Conspiracy Theories"
            image="/Images/conspiracy.webp"
            seoTitle="Free English Lesson Plans: Conspiracy Theories"
            seoDescription="Conspiracy theories, critical thinking, and media literacy. B2/C1 level reading, grammar, and discussion exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Conspiracy;


